const INITIAL_STATE = {
  data: {},
  errors: {},
            
}
const batchInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'BATCH_INVOICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'BATCH_INVOICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
            
export default batchInvoice;